"use strict";

import DragBox from "ol/interaction/DragBox";
import {always} from "ol/events/condition";
import jQuery from 'jquery';

/**
 * Control zur Anzeige/zum Kopieren der aktuell unter der Maus befindlichen
 * Koordinaten.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.OLZoomInOutBox = function( options )
{
	gc.gis.control.GCAbstractMapControl.call( this, options );

	/**
	 * Bedienungshinweis, wenn Control aktiv ist
	 * @private
	 * @type {gc.gis.ui.GCInteractionMessage}
	 */
	this.__interaction_message = {
		title:   'Zur Auswahl zoomen',
		icon:    'mouse-button-left',
		message: 'Ziehen Sie mit der linken Maustaste ein Rechteck auf.'
	};
	if( gc.gis.iface.env.device === gc.gis.env.device.MOBILE )
	{
		this.__interaction_message = {
			title:   'Zur Auswahl zoomen',
			icon:    'touch-pointer',
			message: 'Ziehen Sie mit dem Finger ein Rechteck auf.'
		};
	}
	else
	{
		this.__interaction_message = {
			title:   'Zur Auswahl zoomen',
			icon:    'mouse-button-left',
			message: 'Ziehen Sie mit der linken Maustaste ein Rechteck auf.'
		};
	}

	/**
	 * @private
	 * @type {ol.Map}
	 */
	this.__ol_map = undefined;

	/**
	 * @private
	 * @type {ol.interaction.DragZoom}
	 */
	this.__interaction = undefined;

	const self = this;
	this._map.on( gc.gis.map.GCMapEvent.INTERACTION_ACTIVATED, this, function(evt ) {
		if( evt.interaction === self.__interaction )
		{
			gc.gis.iface.log.debug( self, self.__interaction.get('_gc_name') + ' was activated.');
			self.onInteractionActivated();
		}
	});
	this._map.on( gc.gis.map.GCMapEvent.INTERACTION_DEACTIVATED, this, function(evt ) {
		if( evt.interaction === self.__interaction )
		{
			gc.gis.iface.log.debug( self, self.__interaction.get('_gc_name') + ' was deactivated.');
			self.onInteractionDeactivated();
		}
	});
};
gc.gis.control.OLZoomInOutBox.prototype = Object.create( gc.gis.control.GCAbstractMapControl.prototype );

/**
 * @inheritdoc
 */
gc.gis.control.OLZoomInOutBox.prototype.init = function()
{
	const self = this;

	this.__interaction = new DragBox({
		condition: always
	});
	this.__ol_map = this._map.getMap().getImpl();
	this.__interaction.setActive( false );
	this.__ol_map.addInteraction( this.__interaction );
	this.__interaction.set('_is_gc', true, true);
	this.__interaction.set('_gc_name', 'ZoomInOutBox', true);

	const geometryFactory = new gc.gis.geom.OLGeometryFactory();
	this.__interaction.on('boxend', function(evt) {
		self.toggleZoomBox();
        self._map.fitGeometry(geometryFactory.createGeometry(evt.target.getGeometry()));
	});

	this._render();
};

/**
 * Rendert das Control.
 *
 * @protected
 * @return {jQuery} Container-Element
 */
gc.gis.control.OLZoomInOutBox.prototype._render = function()
{
	const self = this;

	if( !this._element )
	{
		this._element = jQuery('<div>', {
			'class': 'gc-map-control gc-map-control-zoom'
		});

		this.__element_zoom_in = jQuery('<button>', {
			'class': 'gc-map-control-button gc-map-control-button-zoom-in',
			title: 'Hineinzoomen',
			html: '<span>Hineinzoomen</span>',
			click: function( evt ) {
				evt.preventDefault();
				try
				{
                    self._map.zoomIn();
				}
				catch( err )
				{
					gc.gis.iface.log.error( self, err );
				}
				jQuery(this).blur();
			}
		});
		this.__element_zoom_in.prepend( jQuery('<span>', {
			'class': 'gc-icon ms ms-plus'
		}) );

		this.__element_zoom_out = jQuery('<button>', {
			'class': 'gc-map-control-button gc-map-control-button-zoom-out',
			title: 'Herauszoomen',
			html: '<span>Herauszoomen</span>',
			click: function( evt ) {
				evt.preventDefault();
				try
				{
                    self._map.zoomOut();
				}
				catch( err )
				{
					gc.gis.iface.log.error( self, err );
				}
				jQuery(this).blur();
			}
		});
		this.__element_zoom_out.prepend( jQuery('<span>', {
			'class': 'gc-icon ms ms-minus'
		}) );

		this.__element_zoom_box = jQuery('<button>', {
			'class': 'gc-map-control-button gc-map-control-button-zoom-box',
			title: 'Zur Auswahl zoomen',
			html: '<span>Zur Auswahl zoomen</span>',
			click: function( evt ) {
				evt.preventDefault();
				try
				{
                    self.toggleZoomBox();
                }
                catch( err )
                {
                    gc.gis.iface.log.error( self, err );
                }
				jQuery(this).blur();
			}
		});
		this.__element_zoom_box.prepend( jQuery('<span>', {
			'class': 'gc-icon ms ms-zoom-box'
		}) );

		this._element.append( this.__element_zoom_in );
		if( gc.gis.iface.env.device !== gc.gis.env.device.MOBILE )
		{
            this._element.append( this.__element_zoom_box );
		}
        this._element.append( this.__element_zoom_out );

		gc.gis.iface.ui.tooltip(this.__element_zoom_in, {
			placement: 'auto left'
		});
		gc.gis.iface.ui.tooltip(this.__element_zoom_out, {
			placement: 'auto left'
		});
		gc.gis.iface.ui.tooltip(this.__element_zoom_box, {
			placement: 'auto left'
		});
	}
	return this._element;
};

/**
 * Schaltet die Interaktion an, wenn aus bzw. vice versa.
 *
 * @public
 */
gc.gis.control.OLZoomInOutBox.prototype.toggleZoomBox = function()
{
	this.__interaction.setActive(!this.__interaction.getActive());
};

/**
 * Blendet die Interaktionshilfe ein. Callback für Openlayers-Event.
 *
 * @public
 */
gc.gis.control.OLZoomInOutBox.prototype.onInteractionActivated = function()
{
	if( this.__element_zoom_box )
	{
		this.__element_zoom_box.addClass('gc-active');
		gc.gis.iface.ui.setInteractionMessage( this.__interaction_message );
	}
};

/**
 * Blendet die Interaktionshilfe aus. Callback für Openlayers-Event.
 *
 * @public
 */
gc.gis.control.OLZoomInOutBox.prototype.onInteractionDeactivated = function()
{
	if( this.__element_zoom_box )
	{
		this.__element_zoom_box.removeClass('gc-active');
		gc.gis.iface.ui.unsetInteractionMessage( this.__interaction_message );
	}
};

